<template>
    <div class="antialiased">
        <Sidebar />
        <div class="page">
            <Header :disabledSearch="false"></Header>
            <div class="content">
                <div class="container pos-relative">
                    <div class="page-header">
                        <div class="row d-flex justify-content-between">
                            <div class="col-auto">
                                <h2 class="page-title">Dua Kelinci Import</h2>
                            </div>
                            <div class="col-auto">
                                <div class="d-flex">
                                    <b-button-group class="h-75 mr-4">
                                        <b-dropdown variant="outline-primary" right text="Download Template">
                                            <b-dropdown-item @click="_downloadTemplate('stt')">STT</b-dropdown-item>
                                            <b-dropdown-item @click="_downloadTemplate('std')">STD</b-dropdown-item>
                                            <b-dropdown-item @click="_downloadTemplate('retur')">Retur</b-dropdown-item>
                                        </b-dropdown>
                                    </b-button-group>
                                    <div class="alert alert-info">
                                        <b> <i class="fe fe-info mr-1"></i> SYARAT UPLOAD!</b> <br />
                                        Format file harus .xlsx atau .xls
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="page-body" v-if="dataDKImport.data.length <= 0">
                        <div class="frame-upload" @dragover.prevent @drop.prevent="_drop">
                            <div class="input-file" :class="condition.isSubmit ? 'active' : ''">

                                <transition name="slide-fade-y">
                                    <div v-if="file.data != null">
                                        <div class="img">
                                            <span v-html="file.size"></span>
                                            <span v-html="file.size"></span>
                                            <img :src="asset('excel.png')" alt="icon-excel" />
                                        </div>
                                        <p v-html="file.name" class="mt-2"></p>
                                    </div>
                                </transition>

                                <div v-if="!condition.isChosed">
                                    <div class="mb-3"> <i class="fa fa-clone" style="margin-bottom: -10px;"></i> </div>
                                    <div style="letter-spacing: 1px">PILIH TYPE IMPORT</div>
                                    <span style="letter-spacing: 0px;">
                                        <button type="button" class="btn btn-sm btn-outline-primary"
                                            style="width: 200px; margin: 2px;"
                                            @click="condition.isChosed = true; file.type = 'stt'">STT</button>
                                    </span><br>
                                    <span style="letter-spacing: 0px;">
                                        <button type="button" class="btn btn-sm btn-outline-primary"
                                            style="width: 200px; margin: 2px;"
                                            @click="condition.isChosed = true; file.type = 'std'">STD</button>
                                    </span><br>
                                    <span style="letter-spacing: 0px;">
                                        <button type="button" class="btn btn-sm btn-outline-primary"
                                            style="width: 200px; margin: 2px;"
                                            @click="condition.isChosed = true; file.type = 'retur'">RETUR</button>
                                    </span><br>
                                </div>

                                <div v-if="condition.isChosed"
                                    @click="condition.isSubmit || !condition.isChosed ? false : $refs.file.click()">
                                    <input type="file" class="d-none" accept=".xlsx,.xls" ref="file" @change="_onFile" />

                                    <div v-if="file.data == null && !condition.hasUploaded">
                                        <div class="mb-3"><i class="fe fe-upload"></i></div>
                                        <div style="letter-spacing: 2px">
                                            UPLOAD FILE EXCEL <br />
                                            ATAU DRAG & DROP DISINI
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <transition name="slide-fade-y">
                            <div class="btn-fly" v-if="file.data != null">
                                <h3 v-if="condition.isSubmit" class="text-center"
                                    v-html="form.time >= 60 ? parseInt(form.time / 60) + ' menit ' + (form.time - 60 * parseInt(form.time / 60)) + ' detik' : form.time + ' detik'">
                                </h3>
                                <button @click="_checkDKImport" :disabled="condition.isSubmit"
                                    class="btn btn-primary btn-pill"
                                    v-html="condition.isSubmit ? spin() + ' Mohon menunggu...' : 'IMPORT'">
                                </button>
                            </div>
                        </transition>
                    </div>

                    <transition name="slide-fade-y">
                        <Skeleton v-if="this.form.loading" type="table" :length="10" class="mt-3 bg-white" />
                        <section class="page-body" v-if="dataDKImport.data.length > 0 && !form.loading">
                            <div class="card">
                                <div class="table-responsive overflow-auto" style="max-height: 680px;">
                                    <table class="table table-vcenter table-hover card-table table-striped table-control">
                                        <thead>
                                            <tr class="text-muted">
                                                <td class="pl-4">No</td>
                                                <td :key="i" class="text-capitalize"
                                                    v-for="(header, i) in dataDKImport.headers">
                                                    {{ header.replaceAll('_', ' ') }}
                                                </td>
                                                <td class="pl-4">Status</td>
                                                <td class=""></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in dataDKImport.data" :key="index">
                                                <td>{{ index + 1 }}</td>
                                                <td :key="i" v-for="(header, i) in dataDKImport.headers">
                                                    <input type="text" class="form-control input-field"
                                                        :class="item.errors.includes(header) ? 'is-invalid' : ''"
                                                        v-model="item.payload[header]">
                                                </td>
                                                <td>
                                                    <span class="badge w-100" :class="item.valid
                                                        ? 'bg-success'
                                                        : 'bg-danger'
                                                        " v-html="item.valid ? 'VALID' : 'TIDAK VALID'"></span>
                                                </td>
                                                <td class="p-0 pos-relative">
                                                    <div class="btn-group option center">
                                                        <button class="btn btn-white btn-pill" @click="_infoData(item)"
                                                            v-html="ic('info')"></button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </section>
                    </transition>
                    <transition name="slide-fade-y">
                        <div v-if="dataDKImport.data.length > 0 && !this.form.loading" class="d-flex flex-row-reverse">
                            <button :disabled="form.isSubmit || !dataDKImport.validate" @click="_storeData" class="btn btn-primary ml-2"
                                :key="2">Store Data</button>
                            <button :disabled="form.isSubmit" @click="_checkData" class="btn btn-outline-primary ml-2"
                                :key="1">re-Check Data</button>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" src="./import.scss" scoped/>
<script>
import helper from "@/assets/js/helper.js";
import { mapState, mapActions } from "vuex";

export default {
    name: "DKImport",
    mixins: [helper],
    data() {
        return {
            file: {
                type: null,
                name: null,
                size: null,
                data: null
            },
            condition: {
                hasUploaded: false,
                isSubmit: false,
                isFinish: false,
                isChosed: false
            },
            form: {
                time: 0,
                loading: false,
                isSubmit: false,
                timeFinish: 0,
                interval: null,
                allowed: ["xlsx", "xls"],
            },
        }
    },
     computed: {
        ...mapState("external_dk", ['dataDKImport'])
    },
    methods: {
        ...mapActions("external_dk", ['checkDKSTTImport', 'recheckDKSTTImport', 'saveDKSTTBatch', 'checkDKSTDImport', 'recheckDKSTDImport', 'saveDKSTDBatch', 'checkDKReturImport', 'recheckDKReturImport', 'saveDKReturBatch']),

        _drop(event) {
            this._onFile(event, { files: event.dataTransfer.files });
        },
        _onFile(event, params) {
            const file = params == null ? event.target.files[0] : params.files[0];
            if (this.form.allowed.indexOf(file.name.split(".").pop()) < 0) {
                this.toast("Format file tidak valid");
                return;
            }

            if (typeof FileReader === "function") {
                const reader = new FileReader();
                setTimeout(
                    () => {
                        reader.onload = (event) => {
                            this.file.data = file;
                            this.file.name = file.name;
                            this.file.size = this.formatBytes(file.size);
                        };
                        this.condition.hasUploaded = true;
                        reader.readAsDataURL(file);
                    }, this.condition.hasUploaded ? 500 : 0
                )
            } else {
                this.toast("FileReader API not supported");
            }
        },

        async _checkDKImport() {
            this.condition.isSubmit = true;
            let payload = new FormData();
            payload.append('file', this.file.data);

            let self = this.form;
            self.time = 1;
            self.timeFinish = 1;

            this.interval = setInterval(function () {
                self.time = self.time + 1;
                self.timeFinish = self.timeFinish + 1;
            }, 1000);

            try {
                if (this.file.type == 'stt') await this.checkDKSTTImport(payload);
                if (this.file.type == 'std') await this.checkDKSTDImport(payload);
                if (this.file.type == 'retur') await this.checkDKReturImport(payload);

                clearInterval(this.interval);
                this.form.loading = false;
                this.condition.isSubmit = false;
                this.file.data = null;
                this.condition.hasUploaded = false;
                this.condition.isFinish = true;
            } catch (error) {
                this.onError(error);
                this.condition.isSubmit = false;
                this.condition.isFinish = true;
                clearInterval(this.interval);
            }
        },

        _infoData(data) {
            let textStatus = "Data SK STT valid";
            let textField = "Format data sudah benar";
            if (!data.valid) {
                textStatus = "Data dk STT tidak valid";
                textField = "Mohon periksa kembali data DK STT";
            }
            if (data.errors.length > 0) {
                let listError = data.errors.toString();
                textField = "Mohon periksa kembali data " + listError;
            }
            this.$swal({
                icon: 'warning',
                title: textStatus,
                text: textField,
            })
        },

        async _checkData() {
            this.form.loading = true;
            this.form.isSubmit = true;
            try {
                if (this.file.type == 'stt')  await this.recheckDKSTTImport({ data: this.dataDKImport.data });
                if (this.file.type == 'std')  await this.recheckDKSTDImport({ data: this.dataDKImport.data });
                if (this.file.type == 'retur')  await this.recheckDKReturImport({ data: this.dataDKImport.data });
                this.form.loading = false;
                this.form.isSubmit = false;
            } catch (error) {
                this.form.loading = false;
                this.form.isSubmit = false;
                this.onError(error);
            }
        },
        _storeData() {
            try {
                this.$swal.fire({
                    title: 'Peringatan',
                    text: "Yakin ingin menyimpan?",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, save it!'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.form.isSubmit = true;
                        if (this.file.type == 'stt') await this.saveDKSTTBatch({ data: this.dataDKImport.data });
                        if (this.file.type == 'std') await this.saveDKSTDBatch({ data: this.dataDKImport.data });
                        if (this.file.type == 'retur') await this.saveDKReturBatch({ data: this.dataDKImport.data });
                        this.form.isSubmit = false;
                        this.file.type = null;
                        this.condition.isChosed = false;
                    }
                })
            } catch (error) {
                this.onError(error);
            }
        },
        _downloadTemplate(type) {
            let data_excel = [];
            if (type == 'stt') {
                data_excel = [{
                    "Gudang": '',
                    "OutCode": '',
                    "OutName": '',
                    "Address": '',
                    "Kab": '',
                    "Kecamatan": '',
                    "KodePos": '',
                    "Selektif": '',
                    "NPWP": '',
                    "Nama_PKP": '',
                    "Alamat_PKP": '',
                    "CustType": '',
                    "TypeOtl": '',
                    "Distrik": '',
                    "Lokasi_Pasar": '',
                    "NamaPasar": '',
                    "Rute": '',
                    "Kunjungan": '',
                    "ItemCode": '',
                    "SCode": '',
                    "Status": '',
                    "KodeSupp": '',
                    "Grup": '',
                    "Barcode": '',
                    "Brand": '',
                    "Segmen": '',
                    "Kemasan": '',
                    "Satuan": '',
                    "SlsmName": '',
                    "Team": '',
                    "SPV": '',
                    "QtyDus": '',
                    "QtyPcs": '',
                    "Harga1": '',
                    "Harga2": '',
                    "HargaTrans": '',
                    "Volume": '',
                    "Tahun": '',
                    "Bulan": '',
                    "Hari": '',
                    "TRANSDATE": '',
                    "SubTotal": '',
                    "Diskon": '',
                    "Proposal": '',
                    "PPn": '',
                    "Total": '',
                    "HPP": '',
                    "HargaNett": '',
                    "Week": '',
                    "Driver": '',
                    "Helper": '',
                    "NUMBER": '',
                    "PickSlip": '',
                    "Berat": '',
                    "NoPajak": '',
                    "CUSTID": '',
                    "OutletID": '',
                    "SALESMAN": '',
                    "CATEGORY": '',
                    "SubCategory": '',
                    "PrefVendor": '',
                    "Pembayaran": '',
                    "Term": '',
                    "Keterangan": '',
                    "Vencode": '',
                    "ProInvoice": '',
                    "PJP": '',
                    "NoPO": '',
                }]
            }
            if (type == 'std') {
                data_excel = [{
                    "OutletName": '',
                    "Gudang": '',
                    "Supplier": '',
                    "NUMBER": '',
                    "No_Faktur": '',
                    "Date": '',
                    "TglKirim": '',
                    "TglFaktur": '',
                    "ItemCode": '',
                    "Grup": '',
                    "StockCode": '',
                    "Brand": '',
                    "QtyDus": '',
                    "QtyPcs": '',
                    "PRICE": '',
                    "DISCP": '',
                    "DiscP_Nom": '',
                    "DISCN": '',
                    "Total_Disc": '',
                    "SubTotal": '',
                    "PPn": '',
                    "GrandTotal": '',
                    "OutletID": '',
                    "CATEGORY": '',
                    "VENCODE": '',
                    "SubCategory": '',
                    "SCode": '',
                }]
            }
            if (type == 'retur') {
                data_excel = [{
                    "NUMBER": '',
                    "Gudang": '',
                    "Tgl_Retur": '',
                    "Tgl_Klaim": '',
                    "Kode_Outlet": '',
                    "Nama_Toko": '',
                    "Alamat": '',
                    "Team": '',
                    "Brand": '',
                    "KategoriRetur": '',
                    "ID_Barang": '',
                    "Kode_Barang": '',
                    "SuppCode": '',
                    "QtyDus": '',
                    "QtyPcs": '',
                    "Volume": '',
                    "Harga0": '',
                    "NPWP": '',
                    "SubTotal": '',
                    "Disc": '',
                    "PPn": '',
                    "Total": '',
                    "ExpDate": '',
                    "Periode": '',
                    "NoPajak": '',
                    "TglPajak": '',
                    "TglBayar": '',
                    "NoInvoice": '',
                    "Kategori": '',
                    "Driver": '',
                }]
            }
            this.createExcel({
                data: data_excel,
                filename: "template_" + type + "_import_SK"
            });
        }
    }
}
</script>


            

